import { createShapeNormalizer, normalizeString } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_STARFISH_SAP_FLOW_EXPERIMENT = defineFcm('starfish_sap_flow_experiment')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				experimentName: { type: 'string', normalizer: normalizeString },
				// Only meaningful on the global value. Controls merger behavior:
				// 'default' (or unset): locale > country > global fallback chain.
				// 'locale+country': both locale AND country must be configured; locale is the source of truth.
				mode: { type: 'enum', values: ['default', 'locale+country'] as const, optional: true },
			},
		}),
	)
	.withDefault(undefined)
	.withMerger(({ localeValue, countryValue, globalValue }) => {
		if (globalValue?.mode === 'locale+country') {
			return localeValue !== undefined && countryValue !== undefined ? localeValue : undefined;
		}
		return localeValue ?? countryValue ?? globalValue;
	})
	.toConfig({
		owner: 'squad-starfish',
		scope: 'corgi-front-end',
		context: 'Start a Petition V2 (SAP) flow experiments',
		description:
			'Generic FCM for gating flow-based SAP experiments. Set experimentName to the active experiment name, or leave undefined/empty to show the default SAP flow. Only one flow-based experiment should be active at a time.',
		mergeLogic:
			'Behavior is controlled by the "mode" field set on the global value.\n\nmode: "default" (or unset)\nUses a fallback chain: locale > country > global. The most specific scope with an experimentName wins.\n\nmode: "locale+country"\nBoth a locale AND a country scope must be configured with an experimentName. If only one is set, the experiment is disabled for that request. Locale is used as the source of truth for the experimentName.\nNote: in this mode, the global scope is still required (because "mode" lives there), but its experimentName is not used — set it to something like "__unused__".\n\nIn both modes, an explicit empty string at a scope is treated as invalid and ignored (not overridden by a parent scope).',
		import: false,
		template: { experimentName: 'starfish_sap4_chat', mode: 'default' },
	});
